import React from "react";
import { Text, Link } from "@chakra-ui/react";
import { APP_SIGNIN_ROUTE } from "src/modules/smile/shared/consts";
import useTranslation from "next-translate/useTranslation";
import SharedNextTranslateLink from "src/shared/components/Controls/SharedNextTranslateLink";

const SmileSignupCreateLink = () => {
  const { t } = useTranslation();

  return (
    <Text marginTop="40px" fontWeight="bold" fontSize="14px" lineHeight="17px" textAlign="center">
      {t("smile:pixSignup_alreadyAccountText")}{" "}
      <SharedNextTranslateLink href={APP_SIGNIN_ROUTE} passHref>
        <Link>{t("smile:pixSignup_alreadyAccountLink")}</Link>
      </SharedNextTranslateLink>
    </Text>
  );
};

export default SmileSignupCreateLink;
